(() => {
  if (customElements.get('media-and-text-slider')) {
    return;
  }

  class MediaAndTextSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      this.options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 500,
        autoHeight: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      };

      this.slider = new Swiper(sliderElement, this.options);
    }
  }

  customElements.define('media-and-text-slider', MediaAndTextSlider);
})();

